var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.e3LibComponent,{tag:"component",attrs:{"asset":_vm.asset,"asset-type":_vm.assetType,"asset-module":_vm.assetModule,"asset-general-info":_vm.assetGeneralInfo,"notifications":_vm.notifications}})}
var staticRenderFns = []

export { render, staticRenderFns }